export default "__VITE_ASSET__65fe4f90__"